// Employee Activity — standalone page (org-admin facing, read-only).
//
// Kept as a direct-URL fallback at /dashboard/employee-activity. It is NOT surfaced in
// the sidebar nav anymore — the primary entry point is the "Employee Activity" button on
// the Dashboard, which opens EmployeeActivityModal. Both render the same shared panel.
import React from 'react';
import { Users } from 'lucide-react';
import EmployeeActivityPanel from './EmployeeActivityPanel';

export default function EmployeeActivity() {
  return (
    <div className="p-4 sm:p-6 max-w-5xl mx-auto">
      <div className="mb-4">
        <h1 className="text-xl font-semibold text-gray-900 dark:text-gray-100 flex items-center gap-2">
          <Users size={20} /> Employee Activity
        </h1>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-0.5">
          Live status and activity of your team.
        </p>
      </div>
      <EmployeeActivityPanel active />
    </div>
  );
}
